import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../utils/helpers';
import './CartPage.css';

const CartPage = () => {
  const { cart, removeFromCart, updateQty, cartTotal, clearCart } = useCart();
  const navigate = useNavigate();
  const shipping = 80;
  const total = cartTotal + shipping;

  if (cart.length === 0) return (
    <div className="cart-empty">
      <div className="cart-empty-icon">🛒</div>
      <h2>Your cart is empty</h2>
      <p>Looks like you haven't added anything yet.</p>
      <Link to="/products" className="btn btn-primary">Start Shopping</Link>
    </div>
  );

  return (
    <div className="cart-page">
      <div className="container">
        <div className="cart-header">
          <h1>Shopping <span className="gradient-text">Cart</span></h1>
          <p>{cart.length} item{cart.length > 1 ? 's' : ''}</p>
        </div>

        <div className="cart-layout">
          {/* Cart Items */}
          <div className="cart-items">
            {cart.map((item, i) => (
              <div key={i} className="cart-item card">
                <img
                  src={item.product.thumbnail || 'https://via.placeholder.com/100?text=NORIX'}
                  alt={item.product.name}
                  className="cart-item-img"
                />
                <div className="cart-item-info">
                  <span className="cart-item-cat">{item.product.category}</span>
                  <h3 className="cart-item-name">{item.product.name}</h3>
                  <div className="cart-item-meta">
                    <span className="size-tag">Size: {item.size}</span>
                    {item.isPreOrder && (
                      <span className="preorder-tag">
                        Pre-Order ({item.preOrderType === '50percent' ? '50%' : '100%'} advance)
                      </span>
                    )}
                  </div>
                  <div className="cart-item-footer">
                    <div className="qty-ctrl">
                      <button className="qty-btn" onClick={() => updateQty(item.product._id, item.size, item.quantity - 1)}>−</button>
                      <span className="qty-num">{item.quantity}</span>
                      <button className="qty-btn" onClick={() => updateQty(item.product._id, item.size, item.quantity + 1)}>+</button>
                    </div>
                    <span className="cart-item-price">{formatPrice(item.price * item.quantity)}</span>
                    <button className="remove-btn" onClick={() => removeFromCart(item.product._id, item.size)}>🗑️</button>
                  </div>
                </div>
              </div>
            ))}

            <button className="btn btn-outline clear-btn" onClick={clearCart}>
              🗑️ Clear Cart
            </button>
          </div>

          {/* Order Summary */}
          <div className="cart-summary card">
            <h3 className="summary-title">Order Summary</h3>
            <div className="summary-rows">
              <div className="summary-row">
                <span>Subtotal ({cart.reduce((s, i) => s + i.quantity, 0)} items)</span>
                <span>{formatPrice(cartTotal)}</span>
              </div>
              <div className="summary-row">
                <span>Shipping (Dhaka)</span>
                <span>{formatPrice(shipping)}</span>
              </div>
              <div className="summary-row total-row">
                <span>Total</span>
                <span className="summary-total">{formatPrice(total)}</span>
              </div>
            </div>

            <button
              className="btn btn-primary checkout-btn"
              onClick={() => navigate('/checkout')}
            >
              Proceed to Checkout →
            </button>

            <Link to="/products" className="continue-shopping">
              ← Continue Shopping
            </Link>

            <div className="secure-badges">
              <span>🔒 Secure Checkout</span>
              <span>🚚 Fast Delivery</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
